export default "__VITE_ASSET__CBW864Jt__"